import { useQuery } from "@tanstack/react-query";
import { listGoogleDriveFoldersApiIngestionGoogleDriveFoldersGet, type GoogleDriveFolder } from "@noa/api-core";
import { UploadQueryKey } from "../../query-keys";

/**
 * The Google Drive root folders the backend is configured to sync.
 *
 * They come from the deployment's GOOGLE_DRIVE_FOLDERS rather than being
 * hard-coded like the SharePoint sites, so the sync panel asks for them. An
 * empty list means Google Drive is not configured for this deployment.
 */
export function useGoogleDriveFolders() {
  const { data, isPending, isError, error, refetch } = useQuery({
    queryKey: UploadQueryKey.googleDriveFolders(),
    queryFn: async () => {
      const { data } = await listGoogleDriveFoldersApiIngestionGoogleDriveFoldersGet({ throwOnError: true });
      return data;
    },
  });

  return {
    folders: data ?? ([] as GoogleDriveFolder[]),
    isLoading: isPending,
    isError,
    error,
    refetch,
  };
}
